import { render, staticRenderFns } from "./ServiceDetailTabsSignatures.vue?vue&type=template&id=5f7007aa&scoped=true&"
import script from "./ServiceDetailTabsSignatures.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailTabsSignatures.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetailTabsSignatures.vue?vue&type=style&index=0&id=5f7007aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7007aa",
  null
  
)

export default component.exports